export enum AccountType {
  Supplier = "Supplier",
  Manufacturer = "Manufacturer",
  Builder = "Builder",
  Service = "Service",
  Subcontractor = "Subcontractor",
}
